<div class="ia-period-pair">
  <div class="ia-period-pair__current"><span class="sr-only">Current period: </span><ng-container [ngTemplateOutlet]="current"></ng-container></div>
  <div class="ia-period-pair__previous" [attr.aria-busy]="loading">
    <span class="sr-only">Previous period: </span>
    <ng-container *ngIf="!loading && !failed && hasPrevious; else unavailable" [ngTemplateOutlet]="previous"></ng-container>
    <ng-template #unavailable><span class="ia-period-pair__unavailable">{{ loading ? 'Loading…' : failed ? 'Unavailable' : 'No data' }}</span></ng-template>
  </div>
  <small *ngIf="change as difference" class="ia-period-pair__change" [attr.aria-label]="metric + ': ' + difference + ' versus previous period'">{{ difference }} <span>vs previous</span></small>
</div>
